import { render } from "./UiCell.vue?vue&type=template&id=212f9804"
import script from "./UiCell.vue?vue&type=script&lang=js"
export * from "./UiCell.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src1353221341/src/NewSmartDash/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__